import '@default/scripts/polyfills/closest';

export const writerList = (writersElement) => {
    const openedClass = 'writer-list--opened';
    const writersClass = 'writer-list';
    const hideListTimeout = 400;

    let opened = false;

    const dropdownSelector = writersElement.querySelector('.writer-list__header');
    const writersListElement = writersElement.querySelector('.writer-list__list');

    /**
     * @name closeDropdown
     * @description Skryje seznam dropdownu.
     */
    function closeDropdown() {
        opened = false;
        writersElement.classList.remove(openedClass);

        function hideList() {
            writersListElement.style.display = 'none';
        }

        window.setTimeout(hideList, hideListTimeout);
    }

    /**
     * @name closeDropdownHandler
     * @description Pokud je dropdown otevřený, a klikneme mimo něj, zavře ho.
     *
     * @param {Event} event
     */
    function closeDropdownHandler(event) {
        const currentElement = event.target;

        const isElementInList = Boolean(currentElement.closest(`.${writersClass}`));

        if (!isElementInList) {
            closeDropdown();
            document.removeEventListener('click', closeDropdownHandler, true);
        }
    }

    /**
     * @name toggleDropdown
     * @description Otevírá a zavírá dropdown při kliknutí na tlačítko.
     *
     * @param {Event} event
     */
    function toggleDropdown(event) {
        event.preventDefault();

        if (!opened) {
            writersListElement.style.display = 'block';
            writersElement.classList.add(openedClass);

            opened = true;
            document.addEventListener('click', closeDropdownHandler, true);
        } else {
            closeDropdown();
            document.removeEventListener('click', closeDropdownHandler, true);
        }
    }

    dropdownSelector.addEventListener('click', toggleDropdown);
};
